<template>
    <div class="header-main">
        <!-- <img v-if="faceIcon&&faceIcon.length" class="header-main-top" :src="faceIcon" @click="loginDailogClick" />
        <img v-else class="header-main-top" src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png" /> -->
        <!-- <div v-if="loginDailogShow" class="loginDialogCover" :style="{'width':pageWidth+'px','height':pageHeight+'px'}" @click="loginDailogClick"> -->
        <div class="loginDialogCover" :style="{'width':pageWidth+'px','height':pageHeight+'px'}" @click="loginDailogClick">
            <div class="loginDialog">
                <div class="loginDialogTop">
                    <div class="loginDialogTopL">
                        <img class="faceIcon" :src="faceIcon"/>
                        <img v-if="isVip.length" class="vipIcon" src="https://imagessl.edujia.com/A-1ed71af7_20230807161652.png">
                    </div>
                    <div class="loginDialogTopR">
                        <div class="nickName">{{nickName}}</div>
                        <div class="userId">用户ID：{{userId}}</div>
                        <!-- <div v-if="isVip" class="validate">有效期：{{$common.format(new Date(isVip),"yyyy-MM-dd")}}</div> -->
                        <div v-if="isVip.length" class="validate">有效期：{{isVip}}</div>
                    </div>
                </div>
                <div class="loginDialogBottom" @click="loginOut">退出登录</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        data(){
            return {
               nickName:'',
               faceIcon:'',
               userId:'',
               validate:'',
               isVip:0,
               loginDailogShow:false,
               pageWidth:document.documentElement.clientWidth,
               pageHeight:document.documentElement.clientHeight,
            }
        },
        mounted() {
            this.faceIcon=localStorage.getItem("edujia:group:web:faceIcon")
            this.nickName=localStorage.getItem('edujia:group:web:userName')
            this.userId=localStorage.getItem('edujia:group:web:userid')
            this.isVip=localStorage.getItem('edujia:group:web:isVip')
        },
        methods:{
            loginDailogClick(){
                // this.loginDailogShow=!this.loginDailogShow;
                this.$emit("hide")
            },
            loginOut(){
                sessionStorage.clear()
                localStorage.clear()
                this.$store.commit('resetUserState')
                this.$store.commit('token',null)
                setTimeout(()=>{
                    window.location.reload();
                },100)
                this.$router.push({name:'login'})

            }
        }
    }
</script>

<style scoped>
    .header-main{
        /*width: 100%;
        height: 57px;
        display: flex;
        align-items: center;
        justify-content: flex-end;*/
    }

    .header-main-top{
        width: 32px;
        height: 32px;
        margin-right: 14px;
        object-fit: cover;
    }

    .loginDialogCover{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9999;
    }

    .loginDialog{
        background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230807160904.png");
        width: 261px;
        height: 189px;
        background-size: 261px 189px;
        position: absolute;
        right: 0px;
/*        top: 28px;*/
        top: 68px;
    }

    .loginDialogTop{
        display: flex;
    }

    .loginDialogTopL{
        position: relative;
        margin-top: 32px;
        margin-left: 24px;
        width: 40px;
        height: 40px;
    }

    .loginDialogTopR{
        margin-top: 32px;
        margin-left: 14px;
    }

    .faceIcon{
        width: 40px;
        height: 40px;
        border-radius: 40px;
    }

    .vipIcon{
        width: 24px;
        height: 13px;
        position: absolute;
        bottom: -6.5px;
        left: 50%;
        margin-left: -12px;
    }

    .nickName{
        font-size: 16px;
        color: #3C3C3C;
        font-weight: 500;
    }

    .userId{
        margin-top: 8px;
        font-size: 14px;
    }

    .validate{
        margin-top: 8px;
        font-size: 14px;
    }

    .loginDialogBottom{
        width: 120px;
        height: 32px;
        border: 1px solid #4A90E2;
        border-radius: 4px;
        color: #4A90E2;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        margin-top: 5px;
    }
</style>